import styled from '@emotion/styled/macro'
import { size } from '@styles/theme'

import { MapContainer } from '@components/nearby/MapContainer'
import { PiSpinnerBold } from 'react-icons/pi'
import { LoaderLogo } from './LoaderLogo'

import { austinMapBackground } from '@assets/images/austin-map-background'

const LoadingScreen = styled(MapContainer)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  border: 7px solid rgba(255,255,255, 0.25);
`

const LoadingBackground = styled(MapContainer)`
  top: 0;
  bottom: 0;

  height: 100vh;
  width: 100vw;

  background: url('${austinMapBackground}');
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
`

const MapLoader = ({ isWebsocketConnected, mapDataIsInitialized, profilesInitialized }) => {

  const renderLoadingMessage = () => {
    if (!isWebsocketConnected) {
      return 'Connecting to server'
    } else if (!mapDataIsInitialized) {
      return 'Getting map data'
    } else if (!profilesInitialized) {
      return 'Getting nearby users'
    }
  }

  return (
    <LoadingBackground>
      <LoadingScreen>
        <LoaderLogo>
          <PiSpinnerBold
            strokeWidth={size(1)}
            size={size(2)}
            className='animation_rotation'
          />
          &nbsp;{renderLoadingMessage()}
        </LoaderLogo>
      </LoadingScreen>
    </LoadingBackground>
  )
}

export { MapLoader }
